module.exports = __webpack_public_path__ + "img/binarystar-horizontal-wordmark.f6208d77.svg";